<template>
  <div class="home-container">
    <!-- 卫星轨道动画 -->
    <div class="orbit" style="top: 10%; right: 5%;"></div>
    <div class="orbit" style="bottom: 20%; left: 5%;" :style="{ animationDuration: '15s' }"></div>

    <!-- 数据流动画 -->
    <div class="data-flow"></div>

    <!-- 首页主体内容 -->
    <div class="home-content">
      <!-- 1. 全屏轮播图 -->
      <section class="carousel">
        <div class="carousel-inner">
          <div
            class="carousel-slide fade"
            v-for="(img, index) in carouselImages"
            :key="index"
            :class="{ active: index === currentSlide }"
          >
            <img :src="require(`@/assets/lunbo/lunbo${index + 1}.jpg`)" :alt="`轮播图${index + 1}`" />
          </div>
          <!-- 左右箭头 -->
          <button class="arrow arrow-left" @click="prevSlide">❮</button>
          <button class="arrow arrow-right" @click="nextSlide">❯</button>
        </div>
      </section>

      <!-- 2. 核心下载区 -->
      <section class="download-area">
        <div class="download-card glass">
          <h2>校正软件</h2>
          <div class="software-types">
            <div class="software-type-item" v-for="software in softwareTypes" :key="software.name">
              <div class="software-info">
                <h3>{{ software.name }}</h3>
                <p>{{ software.description }}</p>
              </div>
            </div>
          </div>
          <button class="download-btn" @click="goToDownloadPage">
            查看下载地址
          </button>
        </div>
      </section>

      <!-- 3. 软件介绍卡片区 -->
      <section class="software-cards">
        <h2 class="section-title">软件介绍</h2>
        <div class="cards-grid">
          <div class="software-card" v-for="software in softwareList" :key="software.id">
            <div class="card-header">
              <h3>{{ software.name }}</h3>
              <div class="version-info">
                <span class="version">最新版本：{{ software.latest_version }}</span>
                <span class="date">发布日期：{{ software.release_date }}</span>
              </div>
            </div>
            <div class="card-content">
              <p class="description">{{ software.description }}</p>
              <div class="features">
                <h4>主要功能：</h4>
                <ul>
                  <li v-for="feature in software.features" :key="feature">{{ feature }}</li>
                </ul>
              </div>
            </div>
            <div class="card-footer">
              <button class="card-download-btn" @click="goToDownloadPage">
                查看详情
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- 4. 图文案例区：左图右文 -->
      <!-- <section class="case-area">
        <div class="case-image">
          <img 
            :src="caseData.image_type === 'upload' ? `https://abc.atmcorr.com/api/uploads//cases/${caseData.image_path}` : caseData.image_url" 
            :alt="caseData.title" 
          />
        </div>
        <div class="case-text">
          <h3>{{ caseData.title || '案例展示' }}</h3>
          <p>{{ caseData.short_description || '暂无案例描述' }}</p>
          <div class="case-tags" v-if="caseData.tags">
            <span v-for="(tag, idx) in caseData.tags.split(',')" :key="idx">{{ tag }}</span>
          </div>
          <div class="case-details" v-if="caseData.detail_description">
            <p>{{ caseData.detail_description }}</p>
          </div>
        </div>
      </section> -->

      <!-- 5. 代码教程区 -->
      <section class="tutorial-area">
        <div class="tutorial-flex-row">
          <div class="tutorial-code">
            <img :src="require('@/assets/liucheng.png')" alt="代码截图" />
          </div>
          <div class="tutorial-text">
            <h3>操作教程</h3>
            <ol>
              <li v-for="(step, index) in tutorialData.steps" :key="index">
                <span class="step-number">{{ index + 1 }}.</span>
                {{ step }}
              </li>
            </ol>
          </div>
        </div>
      </section>

      <!-- 6. 行业新闻区（时间轴布局） -->
      <section class="news-area">
        <h3>行业新闻</h3>
        <ul class="timeline">
          <li v-for="news in newsList" :key="news.id">
            <div class="news-date">{{ news.date }}</div>
            <div class="news-content">
              <h4>
                <a :href="news.link" target="_blank" rel="noopener noreferrer">{{ news.title }}</a>
              </h4>
              <p>{{ news.summary || '暂无简要描述' }}</p>
              <span class="news-source" v-if="news.source">来源：{{ news.source }}</span>
            </div>
          </li>
        </ul>
        <router-link to="/news" class="more-news">更多新闻 &raquo;</router-link>
      </section>
    </div>

    <!-- 二维码弹窗 -->
    <div v-if="showQRModal" class="qr-modal-overlay" @click="closeQRModal">
      <div class="qr-modal" @click.stop>
        <div class="qr-modal-header">
          <h3>扫码下载</h3>
          <button class="close-btn" @click="closeQRModal">×</button>
        </div>
        <div class="qr-modal-content">
          <div class="qr-code-container">
            <div v-if="versionInfo && versionInfo.file_type === 'upload'" class="qr-code-image">
              <img 
                :src="`https://abc.atmcorr.com/api/uploads//versions/${versionInfo.file_path}`" 
                :alt="`下载 ${versionInfo.version_number}`"
                @error="handleImageError"
                @load="handleImageLoad"
                @click="previewImage"
                class="download-image"
              />
              <div v-if="imageLoading" class="image-loading">
                <div class="loading-spinner"></div>
                <p>图片加载中...</p>
              </div>
              <div class="image-overlay">
                <span class="preview-hint">点击查看大图</span>
              </div>
            </div>
            <div v-else class="qr-code-placeholder">
              <div class="qr-icon">📱</div>
              <p>二维码加载中...</p>
            </div>
          </div>
          <div class="download-tips">
            <h4>下载提示：</h4>
            <ul>
              <li>下载完成后请按照安装提示进行安装</li>
              <li>如有问题请联系技术支持</li>
            </ul>
          </div>
        </div>
        <div class="qr-modal-footer">
          <button class="cancel-btn" @click="closeQRModal">取消</button>
        </div>
      </div>
    </div>

    <!-- 图片预览弹窗 -->
    <div v-if="showImagePreview" class="image-preview-overlay" @click="closeImagePreview">
      <div class="image-preview-modal" @click.stop>
        <div class="image-preview-header">
          <h3>图片预览</h3>
          <button class="close-btn" @click="closeImagePreview">×</button>
        </div>
        <div class="image-preview-content">
          <img 
            v-if="versionInfo && versionInfo.file_type === 'upload'"
            :src="`https://abc.atmcorr.com/api/uploads//versions/${versionInfo.file_path}`" 
            :alt="`下载 ${versionInfo.version_number}`"
            class="preview-image"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import api from '@/utils/axios';
import { ElMessage } from 'element-plus'
import { mapState } from 'vuex'

export default {
  name: "Home",
  data() {
    return {
      carouselImages: [1, 2, 3],
      currentSlide: 0,
      loading: false,
      versionInfo: {
        version_number: "",
        release_date: "",
        update_log: "",
        file_path: "",
        file_type: ""
      },
      versionList: [],
      // 软件类型列表
      softwareTypes: [
        {
          name: "GAC_MSS国产陆地卫星",
          icon: "🛰️",
          description: "辐射校正软件"
        },
        {
          name: "GAC_PMS国产全色多光谱卫星",
          icon: "📡",
          description: "辐射校正软件"
        },
        {
          name: "GAC_CCD国产16米多光谱卫星",
          icon: "🛸",
          description: "辐射校正软件"
        },
        {
          name: "GAC_AHSI_Water国产高光谱卫星（400-1000nm）",
          icon: "💧",
          description: "辐射校正软件"
        },
        {
          name: "GAC_AHSI_Mineral国产高光谱卫星（400-2500nm）",
          icon: "⛏️",
          description: "辐射校正软件"
        }
      ],
      // 软件详细介绍列表
      softwareList: [
        {
          id: 1,
          name: "GAC_MSS",
          latest_version: "v2.1.0",
          release_date: "2024-01-15",
          description: "可实现国产陆地卫星的辐射校正，包括辐射定标、大气校正、几何校正和一站式处理。",
          features: [
            "辐射定标",
            "大气校正", 
            "几何校正",
            "一站式处理"
          ]
        },
        {
          id: 2,
          name: "GAC_PMS",
          latest_version: "v1.8.0",
          release_date: "2024-01-10",
          description: "可实现多个国产全色多光谱卫星的辐射校正，包括辐射定标、大气校正、几何校正、图像融合、一站式处理、图像镶嵌、辐射批处理等功能。",
          features: [
            "辐射定标",
            "大气校正",
            "几何校正",
            "图像融合",
            "一站式处理",
            "图像镶嵌",
            "辐射批处理"
          ]
        },
        {
          id: 3,
          name: "GAC_CCD",
          latest_version: "v1.5.0",
          release_date: "2024-01-08",
          description: "可实现多个国产16米多光谱卫星的辐射校正，包括辐射定标、大气校正、几何校正、一站式处理、图像镶嵌、辐射批处理等功能。",
          features: [
            "辐射定标",
            "大气校正",
            "几何校正",
            "一站式处理",
            "图像镶嵌",
            "辐射批处理"
          ]
        },
        {
          id: 4,
          name: "GAC_AHSI_Water",
          latest_version: "v1.2.0",
          release_date: "2024-01-05",
          description: "可实现国产高光谱卫星（400-1000nm）的辐射校正，包括辐射定标、大气校正、几何校正、一站式处理、图像镶嵌、辐射批处理等功能。",
          features: [
            "辐射定标",
            "大气校正",
            "几何校正",
            "一站式处理",
            "图像镶嵌",
            "辐射批处理",
            "400-1000nm光谱范围"
          ]
        },
        {
          id: 5,
          name: "GAC_AHSI_Mineral",
          latest_version: "v1.0.0",
          release_date: "2024-01-01",
          description: "可实现国产高光谱卫星（400-2500nm）的辐射校正，包括辐射定标、大气校正、几何校正、一站式处理、图像镶嵌、辐射批处理等功能。",
          features: [
            "辐射定标",
            "大气校正",
            "几何校正",
            "一站式处理",
            "图像镶嵌",
            "辐射批处理",
            "400-2500nm光谱范围"
          ]
        }
      ],
      caseData: {
        title: "",
        short_description: "",
        detail_description: "",
        image_type: "upload",
        image_path: "",
        image_url: "",
        tags: "",
        id: null
      },
      tutorialData: {
        steps: [
          "下载软件。",
          "解压安装。",
          "完成安装，首次登录需要注册账号。",
          "运行主程序。",
          "查看输出结果。"
        ]
      },
      newsList: [],
      showQRModal: false,
      showImagePreview: false,
      imageLoading: false
    };
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isAuthenticated
    }),
    latestVersions() {
      return this.versionList.slice(0, 3);
    }
  },
  mounted() {
    setInterval(() => {
      this.currentSlide = (this.currentSlide + 1) % this.carouselImages.length;
    }, 5000);
    console.log("Home 页面加载完成");
    this.fetchVersions();
    this.fetchNews();
    this.fetchRandomCase();
    this.fetchAllSoftwareVersions();
  },

  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
    },

    async fetchVersions() {
      try {
        this.loading = true;
        const response = await api.get('/downloads/versions');
        console.log('API响应:', response);
        
        // 检查响应数据结构
        const versions = Array.isArray(response) ? response : 
                        (response.data && Array.isArray(response.data) ? response.data : []);
        
        console.log('处理后的版本数据:', versions);
        
        if (versions.length > 0) {
          // 按发布日期排序
          this.versionList = versions.sort((a, b) => 
            new Date(b.release_date) - new Date(a.release_date)
          );
          
          // 设置最新版本信息
          this.versionInfo = {
            id: this.versionList[0].id, // 新增
            version_number: this.versionList[0].version_number || '',
            release_date: this.versionList[0].release_date || '',
            update_log: this.versionList[0].update_log || '',
            file_path: this.versionList[0].file_path || '',
            file_type: this.versionList[0].file_type || ''
          };
          
          console.log('设置的最新版本信息:', this.versionInfo);
          console.log('版本列表:', this.versionList);
        } else {
          console.log('版本数据为空');
          this.$message.warning('暂无版本信息');
        }
      } catch (error) {
        console.error('获取版本信息失败:', error);
        this.$message.error(error.response?.data?.message || '获取版本信息失败');
      } finally {
        this.loading = false;
      }
    },

    async handleDownload() {
      if (!this.isLoggedIn) {
        ElMessage.warning('请先登录后再下载');
        this.$router.push('/login');
        return;
      }

      // 打印 versionInfo
      console.log('versionInfo:', this.versionInfo);

      try {
        // 先记录下载信息
        const res = await api.post('/downloads/record', {
          version_id: this.versionInfo.id
        });
        console.log('下载记录成功', res);

        // 判断文件类型
        if (this.versionInfo.file_type === 'upload') {
          // 上传的文件，弹二维码弹窗
          this.showQRModal = true;
          this.imageLoading = true;
        } else {
          // 外部链接，直接跳转下载
          window.location.href = this.versionInfo.file_path;
          ElMessage.success('开始下载...');
        }
      } catch (error) {
        console.error('记录下载信息失败:', error);
        ElMessage.error('下载记录失败，请稍后重试');
      }
    },

    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.carouselImages.length;
    },
    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.carouselImages.length) % this.carouselImages.length;
    },

    async fetchNews() {
      try {
        const response = await api.get('/news');
        // 检查响应数据结构
        const newsData = Array.isArray(response) ? response : 
                        (response.data && Array.isArray(response.data) ? response.data : []);
        
        this.newsList = newsData.map(news => ({
          ...news,
          date: this.formatNewsDate(news.created_at)
        }));
      } catch (error) {
        console.error('获取新闻列表失败:', error);
        ElMessage.error('获取新闻列表失败');
      }
    },

    formatNewsDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
    },

    async fetchRandomCase() {
      try {
        const response = await api.get('/cases');
        const cases = Array.isArray(response) ? response : 
                     (response.data && Array.isArray(response.data) ? response.data : []);
        
        if (cases.length > 0) {
          // 随机选择一个案例
          const randomIndex = Math.floor(Math.random() * cases.length);
          const randomCase = cases[randomIndex];
          
          this.caseData = {
            title: randomCase.title,
            short_description: randomCase.short_description,
            detail_description: randomCase.detail_description,
            image_type: randomCase.image_type,
            image_path: randomCase.image_path,
            image_url: randomCase.image_url,
            tags: randomCase.tags,
            id: randomCase.id
          };
        }
      } catch (error) {
        console.error('获取随机案例失败:', error);
        ElMessage.error('获取随机案例失败');
      }
    },

    async fetchAllSoftwareVersions() {
      try {
        // 为每个软件获取最新版本
        const promises = this.softwareList.map(async (software) => {
          try {
            const response = await api.get(`/downloads/versions?software_name=${software.name}`);
            const versions = Array.isArray(response.data) ? response.data : 
                           Array.isArray(response) ? response : [];
            
            if (versions.length > 0) {
              // 按发布日期排序，获取最新版本
              const sortedVersions = versions.sort((a, b) => 
                new Date(b.release_date) - new Date(a.release_date)
              );
              
              // 更新软件列表中的版本信息
              software.latest_version = sortedVersions[0].version_number;
              software.release_date = this.formatDate(sortedVersions[0].release_date);
            }
          } catch (error) {
            console.error(`获取${software.name}版本失败:`, error);
          }
        });
        
        await Promise.all(promises);
        console.log('所有软件版本更新完成:', this.softwareList);
      } catch (error) {
        console.error('获取软件版本失败:', error);
      }
    },

    handleImageError(event) {
      console.error('图片加载失败:', event);
      this.imageLoading = false;
    },

    handleImageLoad() {
      this.imageLoading = false;
    },

    previewImage() {
      this.showQRModal = false;
      this.showImagePreview = true;
    },

    closeQRModal() {
      this.showQRModal = false;
    },

    closeImagePreview() {
      this.showImagePreview = false;
    },

    goToDownloadPage() {
      this.$router.push('/download');
    }
  }
}
</script>

<style scoped>
/* ========== CSS变量定义 ========== */
:root {
  --bg-dark: #0A0A0F;
  --bg-darker: #050507;
  --primary: #00B4FF;
  --secondary: #00F7FF;
  --accent: #FF00FF;
  --text-primary: #E0E0FF;
  --text-secondary: #B0B0FF;
  --card-bg: rgba(10, 10, 15, 0.8);
  --quantum-glow: linear-gradient(135deg, var(--primary), var(--secondary));
}

/* ========== 整体布局 ========== */
.home-container {
  position: relative;
  min-height: 100vh;
  background: var(--bg-dark);
  overflow-x: hidden;
}

.home-container::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(circle at 50% 50%, rgba(0, 180, 255, 0.1) 0%, transparent 50%),
    linear-gradient(45deg, rgba(0, 247, 255, 0.05) 25%, transparent 25%),
    linear-gradient(-45deg, rgba(255, 0, 255, 0.05) 25%, transparent 25%);
  background-size: 100% 100%, 60px 60px, 60px 60px;
  background-position: center center, 0 0, 0 0;
  pointer-events: none;
  z-index: 0;
}

/* 首页内容 */
.home-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* ========== 1. 全屏轮播图 ========== */
.carousel {
  width: 1200px;
  margin: 10px;
  height: 60vh;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0, 180, 255, 0.2);
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.1);
}

.carousel-inner {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 1s ease;
}

.carousel-slide.active {
  opacity: 1;
}

.carousel-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(0.8) contrast(1.2);
}

/* 左右箭头按钮 */
.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 180, 255, 0.2);
  color: var(--text-primary);
  border: 1px solid rgba(0, 180, 255, 0.3);
  padding: 15px;
  cursor: pointer;
  border-radius: 50%;
  font-size: 1.8rem;
  transition: all 0.3s;
  z-index: 2;
  backdrop-filter: blur(5px);
}

.arrow:hover {
  background: rgba(0, 180, 255, 0.3);
  box-shadow: 0 0 15px var(--primary);
}

.arrow-left {
  left: 20px;
}

.arrow-right {
  right: 20px;
}

/* ========== 2. 核心下载区 ========== */
.download-area {
  margin: 20px 0;
  width: 90%;
  max-width: 1200px;
  display: flex;
  justify-content: center;
}

.download-card {
  background: var(--card-bg);
  backdrop-filter: blur(10px);
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.1);
  text-align: center;
  border: 1px solid rgba(0, 180, 255, 0.2);
  position: relative;
  overflow: hidden;
  width: 100%;
}

.software-types {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  margin: 15px 0;
}

.software-type-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: rgba(0, 180, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(0, 180, 255, 0.2);
  transition: all 0.3s ease;
}

.software-type-item:hover {
  background: rgba(0, 180, 255, 0.1);
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(0, 180, 255, 0.2);
}

.software-info h3 {
  color: var(--primary);
  margin: 0 0 3px 0;
  font-size: 0.85rem;
  text-shadow: 0 0 8px rgba(0, 180, 255, 0.5);
  line-height: 1.2;
}

.software-info p {
  color: var(--text-secondary);
  margin: 0;
  font-size: 0.75rem;
}

.download-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, transparent, rgba(0, 180, 255, 0.1), transparent);
  transform: translateX(-100%);
  animation: shine 3s infinite;
}

@keyframes shine {
  100% {
    transform: translateX(100%);
  }
}

.download-card h2 {
  color: var(--primary);
  margin-bottom: 10px;
  font-size: 1.8rem;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.download-card p {
  color: var(--text-secondary);
  margin-bottom: 10px;
  font-size: 1rem;
}

.download-desc {
  margin-bottom: 15px;
  font-size: 1.1rem;
  color: var(--text-primary);
}

.download-btn {
  background: var(--quantum-glow);
  color: var(--text-primary);
  padding: 15px 40px;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s;
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;
}

.download-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: 0.5s;
}

.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 20px var(--primary);
}

.download-btn:hover::before {
  left: 100%;
}

/* ========== 3. 软件介绍卡片区 ========== */
.software-cards {
  width: 90%;
  max-width: 1400px;
  margin:  auto;
}

.section-title {
  text-align: center;
  color: var(--primary);
  font-size: 2.5rem;
  margin-bottom: 40px;
  text-shadow: 0 0 20px rgba(0, 180, 255, 0.5);
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.software-card {
  background: var(--card-bg);
  backdrop-filter: blur(15px);
  border-radius: 20px;
  border: 1px solid rgba(0, 180, 255, 0.2);
  box-shadow: 0 0 30px rgba(0, 180, 255, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.software-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 40px rgba(0, 180, 255, 0.2);
  border-color: rgba(0, 180, 255, 0.4);
}

.software-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, transparent, rgba(0, 180, 255, 0.05), transparent);
  transform: translateX(-100%);
  animation: shine 4s infinite;
}

.card-header {
  padding: 15px 20px 10px 20px;
  border-bottom: 1px solid rgba(0, 180, 255, 0.2);
  background: linear-gradient(135deg, rgba(0, 180, 255, 0.1), rgba(0, 247, 255, 0.05));
}

.card-header h3 {
  color: var(--primary);
  font-size: 1.1rem;
  margin: 0 0 10px 0;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
  line-height: 1.3;
}

.version-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.version-info span {
  color: var(--text-secondary);
  font-size: 0.8rem;
  padding: 3px 8px;
  background: rgba(0, 180, 255, 0.1);
  border-radius: 4px;
  border: 1px solid rgba(0, 180, 255, 0.2);
}

.card-content {
  padding: 15px 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.description {
  color: var(--text-primary);
  line-height: 1.5;
  margin-bottom: 15px;
  font-size: 0.9rem;
  text-indent: 2em;
  flex: 1;
}

.features {
  margin-top: auto;
}

.features h4 {
  color: var(--primary);
  margin: 0 0 10px 0;
  font-size: 0.95rem;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.features ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.features li {
  color: var(--text-secondary);
  padding: 4px 8px;
  font-size: 0.85rem;
  background: rgba(0, 180, 255, 0.1);
  border-radius: 4px;
  border: 1px solid rgba(0, 180, 255, 0.2);
  white-space: nowrap;
}

.card-footer {
  padding: 10px 20px 15px 20px;
  border-top: 1px solid rgba(0, 180, 255, 0.2);
  background: rgba(0, 0, 0, 0.1);
  margin-top: auto;
}

.card-download-btn {
  width: 100%;
  padding: 8px 16px;
  background: var(--quantum-glow);
  color: var(--text-primary);
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
  position: relative;
  overflow: hidden;
}

.card-download-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: 0.5s;
}

.card-download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(0, 180, 255, 0.4);
}

.card-download-btn:hover::before {
  left: 100%;
}


/* ========== 4. 图文案例区 ========== */
.case-area {
  width: 90%;
  max-width: 1200px;
  margin: 20px auto;
  display: flex;
  gap: 20px;
  align-items: center;
  background: var(--card-bg);
  padding: 20px;
  border-radius: 16px;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.1);
  border: 1px solid rgba(0, 180, 255, 0.2);
  backdrop-filter: blur(10px);
}

.case-image {
  flex: 0 0 60%;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}

.case-image::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, transparent, rgba(0, 180, 255, 0.2), transparent);
  transform: translateX(-100%);
  animation: shine 3s infinite;
}

.case-image img {
  width: 100%;
  border-radius: 8px;
  transition: transform 0.3s;
  filter: brightness(0.8) contrast(1.2);
}

.case-image:hover img {
  transform: scale(1.02);
}

.case-text {
  flex: 0 0 40%;
  text-align: left;
  padding: 20px;
}

.case-text h3 {
  margin-bottom: 15px;
  font-size: 1.8rem;
  color: var(--primary);
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.case-text p {
  color: var(--text-secondary);
  line-height: 1.8;
  font-size: 1.1rem;
  margin-bottom: 15px;
}

.case-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 15px 0;
}

.case-tags span {
  background: rgba(0, 180, 255, 0.2);
  color: var(--text-primary);
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 0.9rem;
  border: 1px solid rgba(0, 180, 255, 0.3);
  transition: all 0.3s;
}

.case-tags span:hover {
  background: rgba(0, 180, 255, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 0 10px rgba(0, 180, 255, 0.2);
}

.case-details {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(0, 180, 255, 0.2);
}

.case-details p {
  font-size: 1rem;
  line-height: 1.6;
  color: var(--text-secondary);
  opacity: 0.9;
}

/* ========== 5. 代码教程区 ========== */
.tutorial-area {
  width: 90%;
  max-width: 1200px;
  margin: 20px auto;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  background: var(--card-bg);
  padding: 20px;
  border-radius: 16px;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.1);
  border: 1px solid rgba(0, 180, 255, 0.2);
  backdrop-filter: blur(10px);
}

.tutorial-flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
}

.tutorial-code {
  flex: 0 0 48%;
  border: 1px solid rgba(0, 180, 255, 0.2);
  padding: 20px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.3);
  position: relative;
  overflow: hidden;
}

.tutorial-code::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, transparent, rgba(0, 180, 255, 0.1), transparent);
  transform: translateX(-100%);
  animation: shine 3s infinite;
}

.tutorial-code img {
  width: 100%;
  border-radius: 4px;
  filter: brightness(0.8) contrast(1.2);
}

.tutorial-text {
  flex: 0 0 48%;
  text-align: left;
}

.tutorial-text h3 {
  color: var(--primary);
  margin-bottom: 15px;
  font-size: 1.8rem;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.tutorial-text ol {
  padding-left: 0;
  list-style: none;
}

.tutorial-text li {
  margin-bottom: 15px;
  position: relative;
  padding-left: 30px;
  font-size: 1.1rem;
  color: var(--text-secondary);
}

.tutorial-text li::before {
  content: '>';
  position: absolute;
  left: 0;
  color: var(--primary);
  font-size: 1.2rem;
}

/* ========== 6. 行业新闻区 ========== */
.news-area {
  width: 90%;
  max-width: 1200px;
  margin: 20px auto;
  text-align: left;
  background: var(--card-bg);
  padding: 20px;
  border-radius: 16px;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.1);
  border: 1px solid rgba(0, 180, 255, 0.2);
  backdrop-filter: blur(10px);
}

.news-area h3 {
  color: var(--primary);
  margin-bottom: 20px;
  font-size: 1.8rem;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.timeline {
  list-style: none;
  padding: 0;
  border-left: 2px solid var(--primary);
  margin-left: 20px;
  position: relative;
}

.timeline::before {
  content: '';
  position: absolute;
  top: 0;
  left: -2px;
  width: 2px;
  height: 100%;
  background: linear-gradient(to bottom, var(--primary), var(--secondary));
  filter: blur(1px);
}

.timeline li {
  margin-bottom: 20px;
  position: relative;
  padding-left: 30px;
}

.timeline li::before {
  content: '';
  position: absolute;
  left: -10px;
  top: 0;
  width: 12px;
  height: 12px;
  background: var(--primary);
  border-radius: 50%;
  box-shadow: 0 0 10px var(--primary);
}

.news-date {
  font-weight: bold;
  color: var(--primary);
  margin-bottom: 8px;
  text-shadow: 0 0 5px rgba(0, 180, 255, 0.5);
}

.news-content {
  position: relative;
  padding: 15px;
  background: rgba(0, 180, 255, 0.05);
  border-radius: 8px;
  margin-bottom: 10px;
  transition: all 0.3s;
}

.news-content:hover {
  background: rgba(0, 180, 255, 0.1);
  transform: translateX(5px);
}

.news-content h4 {
  margin: 0 0 10px 0;
}

.news-content h4 a {
  color: var(--text-primary);
  text-decoration: none;
  transition: all 0.3s;
  font-size: 1.1rem;
}

.news-content h4 a:hover {
  color: var(--secondary);
  text-shadow: 0 0 10px var(--secondary);
}

.news-content p {
  color: var(--text-secondary);
  margin: 0 0 10px 0;
  font-size: 0.95rem;
  line-height: 1.6;
}

.news-source {
  display: inline-block;
  font-size: 0.85rem;
  color: var(--primary);
  opacity: 0.8;
}

.more-news {
  display: inline-block;
  margin-top: 20px;
  color: var(--primary);
  text-decoration: none;
  transition: all 0.3s;
  padding: 10px 20px;
  border: 1px solid rgba(0, 180, 255, 0.3);
  border-radius: 4px;
}

.more-news:hover {
  color: var(--secondary);
  background: rgba(0, 180, 255, 0.1);
  box-shadow: 0 0 15px rgba(0, 180, 255, 0.2);
}

/* ========== 动画效果 ========== */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 添加卫星轨道动画 */
@keyframes orbit {
  0% {
    transform: rotate(0deg) translateX(150px) rotate(0deg);
  }
  100% {
    transform: rotate(360deg) translateX(150px) rotate(-360deg);
  }
}

.orbit {
  position: absolute;
  width: 300px;
  height: 300px;
  border: 1px solid rgba(0, 180, 255, 0.2);
  border-radius: 50%;
  animation: orbit 20s linear infinite;
}

.orbit::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  background: var(--primary);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 10px var(--primary);
}

/* 添加数据流动画 */
@keyframes dataFlow {
  0% {
    background-position: 0% 0%;
  }
  100% {
    background-position: 100% 100%;
  }
}

.data-flow {
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, 
    transparent 0%,
    rgba(0, 180, 255, 0.1) 25%,
    transparent 50%,
    rgba(0, 247, 255, 0.1) 75%,
    transparent 100%
  );
  background-size: 200% 200%;
  animation: dataFlow 10s linear infinite;
  pointer-events: none;
}

/* ========== 二维码弹窗样式 ========== */
.qr-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.qr-modal {
  background: var(--card-bg);
  border-radius: 16px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 0 30px rgba(0, 180, 255, 0.3);
  border: 1px solid rgba(0, 180, 255, 0.3);
  backdrop-filter: blur(15px);
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.qr-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(0, 180, 255, 0.2);
  background: linear-gradient(135deg, rgba(0, 180, 255, 0.1), rgba(255, 0, 255, 0.1));
}

.qr-modal-header h3 {
  color: var(--primary);
  margin: 0;
  font-size: 20px;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.close-btn {
  background: transparent;
  border: none;
  color: var(--text-secondary);
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s;
}

.close-btn:hover {
  background: rgba(255, 0, 0, 0.2);
  color: #ff4444;
  transform: rotate(90deg);
}

.qr-modal-content {
  padding: 24px;
  max-height: 60vh;
  overflow-y: auto;
}

.qr-code-container {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.qr-code-image {
  position: relative;
  width: 200px;
  height: 200px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.2);
  border: 2px solid rgba(0, 180, 255, 0.3);
}

.download-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: rgba(0, 180, 255, 0.05);
  transition: transform 0.3s ease;
}

.download-image:hover {
  transform: scale(1.05);
}

.qr-code-placeholder {
  width: 200px;
  height: 200px;
  border: 2px dashed rgba(0, 180, 255, 0.3);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 180, 255, 0.05);
  color: var(--text-secondary);
}

.qr-icon {
  font-size: 48px;
  margin-bottom: 10px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.download-tips {
  background: rgba(0, 180, 255, 0.05);
  border-radius: 8px;
  padding: 16px;
  border-left: 4px solid var(--primary);
}

.download-tips h4 {
  color: var(--primary);
  margin: 0 0 12px 0;
  font-size: 16px;
}

.download-tips ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.download-tips li {
  color: var(--text-secondary);
  margin-bottom: 8px;
  padding-left: 20px;
  position: relative;
  font-size: 14px;
}

.download-tips li::before {
  content: '•';
  color: var(--primary);
  position: absolute;
  left: 0;
  font-weight: bold;
}

.qr-modal-footer {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid rgba(0, 180, 255, 0.2);
  background: rgba(0, 0, 0, 0.1);
}

.cancel-btn {
  flex: 1;
  padding: 12px 20px;
  border-radius: 8px;
  border: 1px solid rgba(0, 180, 255, 0.3);
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.cancel-btn:hover {
  background: rgba(255, 0, 0, 0.1);
  border-color: #ff4444;
  color: #ff4444;
}

.image-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
}

.image-loading .loading-spinner {
  width: 30px;
  height: 30px;
  border: 3px solid rgba(0, 180, 255, 0.1);
  border-radius: 50%;
  border-top: 3px solid var(--primary);
  animation: spin 1s linear infinite;
}

.image-loading p {
  color: var(--text-primary);
  margin-top: 10px;
  font-size: 12px;
}

/* 图片预览弹窗样式 */
.image-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  backdrop-filter: blur(10px);
}

.image-preview-modal {
  background: var(--card-bg);
  border-radius: 16px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 0 40px rgba(0, 180, 255, 0.4);
  border: 1px solid rgba(0, 180, 255, 0.3);
  backdrop-filter: blur(15px);
  animation: modalSlideIn 0.3s ease-out;
}

.image-preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(0, 180, 255, 0.2);
  background: linear-gradient(135deg, rgba(0, 180, 255, 0.1), rgba(255, 0, 255, 0.1));
}

.image-preview-header h3 {
  color: var(--primary);
  margin: 0;
  font-size: 20px;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.image-preview-content {
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  max-height: 70vh;
  overflow: auto;
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.2);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  cursor: pointer;
}

.qr-code-image:hover .image-overlay {
  opacity: 1;
}

.preview-hint {
  color: var(--text-primary);
  font-size: 14px;
  background: rgba(0, 0, 0, 0.7);
  padding: 8px 12px;
  border-radius: 6px;
  backdrop-filter: blur(5px);
}
</style>